const globalSliders = document.querySelectorAll('[data-slider="global-group-module"]');

const globalSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    1024: {
      spaceBetween: 20,
    },
  },
};

globalSliders.forEach((el) => new Swiper(el, globalSliderOptions));
